const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = [{
    dataIndex: 0,
    id: '3pool',
    name: '3pool',
    lpTokenInfo: {
        name: '3poolCurve',
        symbol: '3poolCrv',
    },
    assets: 'DAI+USDC+USDT',
    coins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0xC5cfaDA84E902aD92DD40194f0883ad49639b023',
        lpToken: '0xC5cfaDA84E902aD92DD40194f0883ad49639b023',
        gauge: '0xbF7E49483881C76487b0989CD7d9A8239B20CA41',
    },
    gaugeVersion: 3, // No CRV rewards
    hasNoCRVRewards: true,
    additionalRewards: [{
        key: 'WONE3POOL',
        name: 'WONE',
        rewardTokenCoingeckoId: 'harmony',
        rewardTokenDecimals: 18,
        rewardTokenAddress: '0xcf664087a5bb0237a0bad6742852ec6c8d69a27a',
        rewardContract: '0xf2Cde8c47C20aCbffC598217Ad5FE6DB9E00b163'
    },
    {
        key: 'CRV3POOL',
        name: 'CRV',
        rewardTokenCoingeckoId: 'curve-dao-token',
        rewardTokenDecimals: 18,
        rewardTokenAddress: '0x352cd428efd6f31b5cae636928b7b84149cf369f',
        rewardContract: '0xf2Cde8c47C20aCbffC598217Ad5FE6DB9E00b163'
    }],
  },
  {
  dataIndex: 1,
  id: 'atricrypto',
  routeOverride: 'tricrypto',
  statsId: 'wtricrypto',
  name: 'tricrypto',
  lpTokenInfo: {
      name: '3CrvCrypto',
      symbol: '3CrvCrypto',
  },
  assets: 'adai+ausdc+ausdt+aeth+abtc',
  coins: [
      coins.dai,
      coins.usdc,
      coins.usdt,
      coins.wbtc,
      coins.weth,
  ],
  addresses: {
      swap: '0x0e3Dc2BcbFEa84072A0c794B7653d3db364154e0',
      lpToken: '0x99E8eD28B97c7F1878776eD94fFC77CABFB9B726',
      deposit: '0x76147c0C989670D106b57763a24410A2a22e335E',
      gauge: '0xF98450B5602fa59CC66e1379DFfB6FDDc724CfC4',
  },
  additionalRewards: [{
      key: 'WONETRICRYPTO',
      name: 'WONE',
      rewardTokenCoingeckoId: 'harmony',
      rewardTokenDecimals: 18,
      rewardTokenAddress: '0xcf664087a5bb0237a0bad6742852ec6c8d69a27a',
      rewardContract: '0x0b2C8fD6110F31F340D3C78A0AEf6c568B60695B'
  }],
  cryptoPool: true,
  referenceAsset: REFERENCE_ASSETS.CRYPTO,
  isFakePlainPool: true,
  gaugeVersion: 3, // No CRV rewards
  hasNoCRVRewards: true,

}
];
